export default {
  title: "Obsah patičky",
  section_title: "Editor patičky",
}
